<div class="item text-black" [class.open]="isOpen()" (click)="handleToggle()">
  <p class="title">{{ title() }}</p>
  <i class="bi" [class]="isOpen() ? 'bi-dash-square' : 'bi-plus-square'"></i>

  <div class="content-box" (click)="$event.stopPropagation()">
    <div>
      <ng-content></ng-content>
    </div>
  </div>
</div>